import { schnorr } from "@noble/curves/secp256k1";
import { bytesToHex, hexToBytes } from "@noble/hashes/utils";
import * as nt04 from "nostr-tools/nip04";
import * as nt44 from "nostr-tools/nip44";
import { generateSecretKey, getPublicKey, getEventHash } from "nostr-tools/pure";
import { cached, now } from "@welshman/lib";
export const makeSecret = () => bytesToHex(generateSecretKey());
export const getPubkey = (secret) => getPublicKey(hexToBytes(secret));
export const getHash = (event) => getEventHash(event);
export const getSig = (event, secret) => bytesToHex(schnorr.sign(event.id, secret));
export const stamp = (event, created_at = now()) => ({ ...event, created_at });
export const own = (event, pubkey) => ({ ...event, pubkey });
export const hash = (event) => ({ ...event, id: getHash(event) });
export const sign = (event, secret) => ({ ...event, sig: getSig(event, secret) });
export const nip04 = {
    detect: (m) => m.includes("?iv="),
    encrypt: (pubkey, secret, m) => nt04.encrypt(secret, pubkey, m),
    decrypt: (pubkey, secret, m) => nt04.decrypt(secret, pubkey, m),
};
export const nip44 = {
    getSharedSecret: cached({
        maxSize: 10000,
        getKey: ([secret, pubkey]) => `${secret}:${pubkey}`,
        getValue: ([secret, pubkey]) => nt44.v2.utils.getConversationKey(hexToBytes(secret), pubkey),
    }),
    encrypt: (pubkey, secret, m) => nt44.v2.encrypt(m, nip44.getSharedSecret(secret, pubkey)),
    decrypt: (pubkey, secret, m) => nt44.v2.decrypt(m, nip44.getSharedSecret(secret, pubkey)),
};
export const decrypt = async (signer, pubkey, message) => nip04.detect(message)
    ? signer.nip04.decrypt(pubkey, message)
    : signer.nip44.decrypt(pubkey, message);
//# sourceMappingURL=util.js.map